import { Box, useMantineColorScheme } from "@mantine/core";
import { BaseContainer } from "../common/BaseContainer";
import { ReportDataToolbar } from "./ReportDataToolbar";
import { ReportResultTable } from "./ReportResultTable";
import { ReportPagination } from "./ReportPagination";

interface ReportResultContainerProps {
    rowCount: number;
    filteredRowsCount: number;
    isExporting: boolean;
    onExport: (type: 'csv' | 'xlsx' | 'json', all: boolean) => void;
    onRowClick: (row: any) => void;
    hideExport?: boolean;
    hidePagination?: boolean;
}

export const ReportResultContainer = ({
    rowCount,
    filteredRowsCount,
    isExporting,
    onExport,
    onRowClick,
    hideExport,
    hidePagination
}: ReportResultContainerProps) => {
    const { colorScheme } = useMantineColorScheme();

    return (
        <BaseContainer>
            <Box
                py={{ base: 6, sm: 'xs' }}
                px={{ base: 'xs', sm: 'md' }}
                style={{
                    borderBottom: '1px solid',
                    borderColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'var(--mantine-color-gray-2)'
                }}
            >
                <ReportDataToolbar
                    rowCount={rowCount}
                    rowsCount={filteredRowsCount}
                    isExporting={isExporting}
                    onExport={onExport}
                    hideExport={hideExport}
                />
            </Box>

            <ReportResultTable onRowClick={onRowClick} />

            {!hidePagination && <ReportPagination />}
        </BaseContainer>
    );
};
